"use strict";

exports.__esModule = true;
exports.TIMESTAMP_REGISTRAR_KEY = void 0;
var TIMESTAMP_REGISTRAR_KEY = '__RRTimestamps';
exports.TIMESTAMP_REGISTRAR_KEY = TIMESTAMP_REGISTRAR_KEY;